<div class="input-grid-gaps grid-1col">
    <app-select-input
        id="serviceId"
        [form]="form"
        label="person.dashboard.dataShare.fields.service"
        [staticOptions]="dashboardStore.allowedServicesToShareFolder()"
        [valueKey]="'id'">
    </app-select-input>
    <app-date-input [form]="form" id="dateFrom"></app-date-input>
    <app-date-input [form]="form" id="dateTo"></app-date-input>
    <app-text-input [form]="form" id="note"></app-text-input>
</div>
